// src/inspector/protocol/actor/to-client.ts
import { z } from "zod";
var ConnSchema = z.object({
  id: z.string(),
  parameters: z.any(),
  state: z.object({
    enabled: z.boolean(),
    value: z.any().optional()
  })
});
var InspectDataSchema = z.object({
  connections: z.array(ConnSchema),
  rpcs: z.array(z.string()),
  state: z.object({
    enabled: z.boolean(),
    value: z.any().optional()
  })
});
var ToClientSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("info")
  }).merge(InspectDataSchema),
  z.object({
    type: z.literal("error"),
    message: z.string()
  })
]);

// src/inspector/protocol/actor/to-server.ts
import { z as z2 } from "zod";
var ToServerSchema = z2.discriminatedUnion("type", [
  z2.object({
    type: z2.literal("info")
  }),
  z2.object({
    type: z2.literal("setState"),
    state: z2.any()
  })
]);

export {
  InspectDataSchema,
  ToClientSchema,
  ToServerSchema
};
//# sourceMappingURL=chunk-B2447XBD.js.map